import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

import styles from './StatusCell.module.scss';

export type CellStatus = 'PUBLISHED' | 'UNPUBLISHED' | 'CLOSED';

type StatusConfig = {
  icon: React.ReactNode;
  label: string;
};

const STATUS_CONFIG: Record<CellStatus, StatusConfig> = {
  PUBLISHED: {
    icon: <CheckCircleOutlined />,
    label: 'Published',
  },
  UNPUBLISHED: {
    icon: <ExclamationCircleOutlined />,
    label: 'Unpublished',
  },
  CLOSED: {
    icon: <CloseCircleOutlined />,
    label: 'Closed',
  },
};

export type StatusCellProps = {
  status: CellStatus;
  tooltipText?: string;
  className?: string;
  name: NamePath;
};

const StatusCellComponent: React.FC<StatusCellProps> = ({
  status,
  tooltipText,
  className = '',
}) => {
  const config = STATUS_CONFIG[status];

  const cell = (
    <div
      className={classNames(
        styles.statusCell,
        styles[status.toLowerCase()],
        className
      )}
    >
      <span className={styles.icon}>{config.icon}</span>
    </div>
  );

  if (!tooltipText) {
    return cell;
  }

  return (
    <Tooltip title={tooltipText} overlayClassName="extranetTooltip">
      {cell}
    </Tooltip>
  );
};

export const StatusCell = React.memo(StatusCellComponent);
